import { call, put } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';

import { createFailed, createSuccessful } from '../actions';
import { CREATED } from '../../../configs/serverStatusCodes';
import makeRequest from '../../../utils/makeRequest';
import processError from '../../../utils/processError';

export default function* create(action) {
  try {
    const {
      name = '',
    } = action.payload;
    const url = `${BACKEND_URL}/roles`;
    const pool = {
      name,
    };
    const dataResponse = yield makeRequest(url, pool, action, 'POST', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === CREATED
      && data
    ) {
      yield put(createSuccessful([]));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(createFailed([]));
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(createFailed([]));
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
